// This file was auto-generated by Fern from our API Definition.
export var ChannelText;
(function (ChannelText) {
    ChannelText.Format = {
        Markdown: "markdown",
        Plain: "plain",
        Html: "html",
    };
})(ChannelText || (ChannelText = {}));
